import { render } from "./ChooseServer.vue?vue&type=template&id=30cfddd2&scoped=true&ts=true"
import script from "./ChooseServer.vue?vue&type=script&lang=ts"
export * from "./ChooseServer.vue?vue&type=script&lang=ts"

import "./ChooseServer.vue?vue&type=style&index=0&id=30cfddd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Spark/Spark/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cfddd2"]])

export default __exports__